import { DefaultButton, Label, mergeStyles } from 'office-ui-fabric-react';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import * as React from 'react';
import { IAgent } from '../../../models/IAgent';
import { IAgentJurisdiction } from '../../../models/IAgentJurisdiction';
import { IModalDialog } from '../../../models/IModalDialog';
import { ITerms } from '../../../models/ITerms';
import ConnectionContext from '../../../utils/ConnectionContext';
import AgentChargesUpdate from '../AgentChargesUpdate/AgentChargesUpdate';
import AgentContactInfo from '../AgentContactInfo/AgentContactInfo';
import AgentTermsServices from '../AgentTerms/AgentTermsServices';
import { IAgentProfileProps } from './IAgentProfileProps';
import { IAgentProfileState } from './IAgentProfileState';
initializeIcons();
const topPanel = mergeStyles({ marginTop: "-20px" });
const menuBar = mergeStyles({ width: "100%", padding: "5px" });
const submitButton = mergeStyles({ backgroundColor: '#73797D' });
export default class AgentProfile extends React.Component<IAgentProfileProps, IAgentProfileState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    constructor(props: IAgentProfileProps, state: IAgentProfileState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.state = {
            hideCharges: true,
            hideTerms: true,
            hideProfile: false,
            agentProfileToView: {
                AgentName: '', City: '', ContactPerson: '', Country: '', CountryCode: '', CPEmailAddress: '', EmailAddress: '', FirmAddress1: '',
                FirmAddress2: '', PhoneNumber: '', PostalCode: '', ServicesOfferedFor: '', State: '', VatRegNo: ''
            },
            agent: {
                agentJurisdiction: [], city: '', companyEmail: '', contactPerson: '', countryCode: '', countryName: '', emailId: '', firmAddress1: '',
                firmAddress2: '', firmName: '', phoneNumber: '', postalCode: '', state: '', vatRegNo: '', id: ''
            },
            terms: {
                id: '', aaCurrency: '', anyOtherAward: '', businessTerms: '', conductCodes: '', docketingSystem: '', employees: 0, iAnnualAggregate: 0,
                iCurrency: '', iMaxAmount: 0, indemnityInsurance: '', itSec: '', itSecStd: '', lawAttorneys: 0, papctLastYear: 0, patentAttorneys: 0,
                patentProsecRank: 0, profConduct: '', ptoNames: [], qtyMgmt: '', qtyMgmtStd: '', rpaLastYear: 0, rtaLastYear: 0, serviceTerms: true,
                tamaLastYear: 0, technicalCompetenceAgent: [], trademarkAttorneys: 0, tradeProsecRank: 0, agentId: ''
            },
            hideDialog: true
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public async componentDidMount() {
        this.getAgentProfile();
    }
    public render(): React.ReactElement<IAgentProfileProps> {
        const tabOptions: IChoiceGroupOption[] = [
            { key: 'profile', text: 'Profile', iconProps: { iconName: 'ContactInfo' } },
            { key: 'terms', text: 'Terms', iconProps: { iconName: 'EntitlementPolicy' } },
            { key: 'charges', text: 'Charges', iconProps: { iconName: 'AllCurrency' } },
            { key: 'close', text: 'Close', iconProps: { iconName: 'Leave' } }
        ];
        return (
            <div className={topPanel}>
                <div>
                    <div className={menuBar}>
                        <ChoiceGroup defaultSelectedKey="profile" options={tabOptions} onChange={this.onChangingMemuItem}
                            styles={{
                                flexContainer: [
                                    {
                                        backgroundColor: "#ffffff",
                                        selectors: {
                                            ".ms-ChoiceField": {
                                                backgroundColor: "#BDD6DD",
                                                color: "#005269",
                                                fontSize: "10px"
                                            }
                                        }
                                    }
                                ]
                            }} />
                    </div>
                </div>
                {
                    (!this.state.hideProfile &&
                        <div className={menuBar}>
                            <div>
                                <AgentContactInfo connectionContext={this.connectionContext} agentProfile={this.state.agentProfileToView} />
                            </div>
                        </div>)
                }
                {
                    (!this.state.hideTerms &&
                        <div className={menuBar}>
                            <div>
                                <AgentTermsServices connectionContext={this.connectionContext} agentMaster={this.state.agent} terms={this.state.terms} />
                            </div>
                        </div>)
                }
                {
                    (!this.state.hideCharges &&
                        <div className={menuBar}>
                            <div>
                                <AgentChargesUpdate connectionContext={this.connectionContext} agentMaster={this.state.agent} />
                            </div>
                        </div>)
                }
                {
                    <div>
                        <div>
                            <Dialog
                                hidden={this.state.hideDialog}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: this.dialog.dialogMessage,
                                }}
                                maxWidth="1024px"
                                closeButtonAriaLabel="Ok"
                            >
                                <div>
                                    <div>
                                        <Label> {this.dialog.dialogBody} </Label>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <DefaultButton onClick={this.closeModelPopUpM} data-automation-id="test" text="Close" className={submitButton} iconProps={{ iconName: "ChromeClose" }} />
                                </DialogFooter>
                            </Dialog>
                        </div>
                    </div>
                }
            </div>
        );
    }
    private onChangingMemuItem = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {
        this.setState((prevState: IAgentProfileState): IAgentProfileState => {
            if (option) {
                if (option.key == "profile") { prevState.hideProfile = false; prevState.hideTerms = true; prevState.hideCharges = true; }
                if (option.key == "terms") { prevState.hideProfile = true; prevState.hideTerms = false; prevState.hideCharges = true; }
                if (option.key == "charges") { prevState.hideProfile = true; prevState.hideTerms = true; prevState.hideCharges = false; }
                if (option.key == "close") { this.props.onClose(); }
            }
            return prevState;
        });
    }
    private getAgentProfile = async (): Promise<void> => {
        try {
            let serviceJurisdiction: string = "";
            let agent: IAgent | null = null;
            if (this.props.agentId != null) {
                agent = await this.connectionContext.get(`Agent/${this.props.agentId}/admin`);
            }
            let terms: ITerms | null = null;
            if (agent != null) {
                terms = await this.connectionContext.get(`Terms/${agent.id}`);
            }
            this.setState((prevState: IAgentProfileState): IAgentProfileState => {
                if (agent != null) {
                    prevState.agent = agent;
                    prevState.agentProfileToView.AgentName = agent.firmName;
                    prevState.agentProfileToView.VatRegNo = agent.vatRegNo;
                    prevState.agentProfileToView.EmailAddress = agent.emailId;
                    prevState.agentProfileToView.FirmAddress1 = agent.firmAddress1;
                    prevState.agentProfileToView.FirmAddress2 = agent.firmAddress2;
                    prevState.agentProfileToView.City = agent.city;
                    prevState.agentProfileToView.State = agent.state;
                    prevState.agentProfileToView.CountryCode = agent.countryCode;
                    prevState.agentProfileToView.Country = agent.countryName;
                    prevState.agentProfileToView.PostalCode = agent.postalCode;
                    prevState.agentProfileToView.ContactPerson = agent.contactPerson;
                    prevState.agentProfileToView.CPEmailAddress = agent.companyEmail;
                    prevState.agentProfileToView.PhoneNumber = agent.phoneNumber;
                    agent.agentJurisdiction.sort((a, b) => a.countryName > b.countryName ? 1 : -1).forEach((item: IAgentJurisdiction) => {
                        serviceJurisdiction = serviceJurisdiction + item.countryName + ", ";
                    });
                    serviceJurisdiction = serviceJurisdiction.substr(0, serviceJurisdiction.length - 2);
                    prevState.agentProfileToView.ServicesOfferedFor = serviceJurisdiction;
                }
                if (terms != null) {
                    prevState.terms = terms;
                }
                return prevState;
            });
        } catch (error) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentProfileState): IAgentProfileState => {
            previousState.hideDialog = false;
            return previousState;
        });
    }
    private closeModelPopUpM = (): void => {
        this.setState((previousState: IAgentProfileState): IAgentProfileState => {
            previousState.hideDialog = true;
            return previousState;
        });
    }
}